import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default () => (dispatch, getState) => {
  const { versions: { currentIndex, sections } } = getState();
  const replacementSections = JSON.parse(sections[currentIndex + 1]);
  dispatch({ type: "VERSIONS/REDO" });
  dispatch({ type: "SECTIONS/REPLACE", payload: { replacementSections } })
  debouncedSaveTemplate(dispatch, getState);
};
